import { PropsWithChildren } from 'react';

import { Column } from 'src/components/flex';

const Properties = ({ children }: PropsWithChildren) => (
  <Column>{children}</Column>
);

export default Properties;
